import React from 'react';
import { PromotingMentalandWell2026 } from '../views';

const SignupSimplePage = () => {
  return <PromotingMentalandWell2026 />;
};

export default SignupSimplePage;
